import { memo } from 'react';

import clsx from 'clsx';

import { type Game } from '@/shared/store/games-store/types';
import { Icon } from '@/shared/ui/icon';

import { ReactComponent as HeartIcon } from '@/assets/images/heart-filled.svg?react';

import { usePlayGame } from '../../hooks/use-play-game';

import s from './index.module.scss';

interface BaseProps {
  game: Game;
  className?: string;
  withFavourite?: boolean;
  placementNum?: number;
}

interface ClickableProps extends BaseProps {
  isClickable: true;
  source: string;
}

interface NonClickableProps extends BaseProps {
  isClickable?: false;
  source?: string;
}

type Props = ClickableProps | NonClickableProps;

export const GameIcon = memo<Props>(
  ({ game, className, withFavourite, isClickable, source, placementNum }) => {
    const { iconUrl, title, favorite } = game;

    const playGame = usePlayGame();

    const Container = isClickable ? 'button' : 'div';

    return (
      <Container
        className={clsx(s.container, isClickable && s.clickable, className)}
        onClick={isClickable ? () => playGame(game, source, placementNum) : undefined}
      >
        <Icon icon={iconUrl} className={clsx(s.icon)} alt={title} />
        {withFavourite && favorite && <HeartIcon className={s['favourite-icon']} />}
      </Container>
    );
  }
);

export const GameIconSkeleton = () => {
  return <div className={clsx(s['skeleton-icon'])} />;
};
